"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = exports.CONCURRENT_PROMISES = exports.MIN_DAYS_TO_NOTIFY = exports.SERVICE_NAME = exports.AdminParentInviteRequestSources = exports.TeacherParentInviteRequestSources = exports.ChildConnectionEventSource = void 0;
// This source is currently only attached to the addMeToParentEmail and notifyParent endpoints.
// This is because ideally we don't need this source since all connection events of the same status should send the same email
// However, since user info service currently handles user sign up emails, we need to prevent duplication of emails.
// Therefore, for connected status, an email is always sent. For pending status, it is only sent if created by addMeToEmail endpoint.
var ChildConnectionEventSource;
(function (ChildConnectionEventSource) {
    /**
     * @deprecated: This comes from user-events sign-up handler called when child user signs up
     */
    ChildConnectionEventSource["USER_SIGN_UP"] = "USER_SIGN_UP";
    /**
     * @deprecated: This comes from user-events update handler when child user changes their guardian email
     */
    ChildConnectionEventSource["GUARDIAN_EMAIL_UPDATE"] = "GUARDIAN_EMAIL_UPDATE";
    // This comes from addMeToParentEmail endpoint called when child adds parent by email
    ChildConnectionEventSource["BY_EMAIL"] = "BY_EMAIL";
    // This comes from addMeToParent endpoint when child uses parent code to connect
    ChildConnectionEventSource["PARENT_CODE"] = "PARENT_CODE";
    // This comes from user-events sign-up and update handlers when parent signs up/changes email
    ChildConnectionEventSource["PARENT_SIGN_UP_OR_EMAIL_UPDATE"] = "PARENT_SIGN_UP_OR_EMAIL_UPDATE";
    // This comes from addMeToParentEmail endpoint when child completes assignment and requests parent to check
    ChildConnectionEventSource["ASSIGNMENT_COMPLETE"] = "ASSIGNMENT_COMPLETE";
    // This comes from addMeToParentEmail endpoint when child completes 10 sessions
    ChildConnectionEventSource["TEN_SESSIONS_COMPLETE"] = "TEN_SESSIONS_COMPLETE";
    // This comes from addMeToParentEmail endpoint when child completes 10 sessions with offering free tutoring session
    ChildConnectionEventSource["TEN_SESSIONS_COMPLETE_TUTORING"] = "TEN_SESSIONS_COMPLETE_TUTORING";
    // NB. ENDPOINT FOR THIS STILL TO BE ADDED
    // This comes from adminCreateParentConnection endpoint when a parent pre-connection is created in a school sync
    ChildConnectionEventSource["MANAGED_SCHOOL_SYNC"] = "MANAGED_SCHOOL_SYNC";
    // Default source for admin create endpoint
    ChildConnectionEventSource["ADMIN_CREATE"] = "ADMIN_CREATE_CONNECTION";
    // This comes from addMeToParentEmail endpoint called when child inputs parent email during sign up
    ChildConnectionEventSource["STUDENT_SIGN_UP_PARENT_EMAIL"] = "STUDENT_SIGN_UP_PARENT_EMAIL";
    // This comes from the notifyParent endpoint when a student clicks 'Share with your parent' on the premium page / checkout
    ChildConnectionEventSource["SHARE_PREMIUM_WITH_PARENT"] = "SHARE_PREMIUM_WITH_PARENT";
    // This comes from the sendStudentParentInviteTenSessionsCompleteEmail endpoint when a student completes 10 sessions
    ChildConnectionEventSource["STUDENT_TEN_SESSIONS"] = "STUDENT_TEN_SESSIONS";
    // This comes from the notifyParent or addMeToParentEmail endpoint when a student redeems the 3 bonus exam questions offer
    ChildConnectionEventSource["PARENT_INVITE_EXAM_QUESTIONS"] = "PARENT_INVITE_EXAM_QUESTIONS";
    // This comes from the notifyParent or addMeToParentEmail endpoint when a student redeems the 3 wrong answer sessions offer
    ChildConnectionEventSource["PARENT_INVITE_WRONG_ANSWERS"] = "PARENT_INVITE_WRONG_ANSWERS";
})(ChildConnectionEventSource = exports.ChildConnectionEventSource || (exports.ChildConnectionEventSource = {}));
var TeacherParentInviteRequestSources;
(function (TeacherParentInviteRequestSources) {
    TeacherParentInviteRequestSources["inviteAllSchoolClasses"] = "invite-all-school-classes";
    TeacherParentInviteRequestSources["inviteYearGroupSchoolClasses"] = "invite-year-group-school-classes";
    TeacherParentInviteRequestSources["inviteBatchClasses"] = "invite-batch-classes";
    TeacherParentInviteRequestSources["inviteBatchParents"] = "invite-batch-parents";
    TeacherParentInviteRequestSources["inviteAllSchoolParents"] = "invite-all-school-parents";
    TeacherParentInviteRequestSources["inviteYearGroupSchoolParents"] = "invite-year-group-school-parents";
    TeacherParentInviteRequestSources["inviteClassesSchoolParents"] = "invite-classes-school-parents";
    TeacherParentInviteRequestSources["inviteStudentReportCards"] = "invite-student-report-cards";
})(TeacherParentInviteRequestSources = exports.TeacherParentInviteRequestSources || (exports.TeacherParentInviteRequestSources = {}));
var AdminParentInviteRequestSources;
(function (AdminParentInviteRequestSources) {
    AdminParentInviteRequestSources["inviteAllSchoolParents"] = "admin-invite-all-school-parents";
    AdminParentInviteRequestSources["inviteYearGroupSchoolParents"] = "admin-invite-year-group-school-parents";
})(AdminParentInviteRequestSources = exports.AdminParentInviteRequestSources || (exports.AdminParentInviteRequestSources = {}));
exports.SERVICE_NAME = 'parents-service';
exports.MIN_DAYS_TO_NOTIFY = 15;
exports.CONCURRENT_PROMISES = 100;
exports.ErrorCodes = {
    CHILDREN_LIMIT_EXCEEDED: 'CHILDREN_LIMIT_EXCEEDED',
    NOT_ALLOWED_TO_CONNECT_TO_SELF: 'NOT_ALLOWED_TO_CONNECT_TO_SELF',
    PARENTS_LIMIT_EXCEEDED: 'PARENTS_LIMIT_EXCEEDED',
    CHILD_CONNECTION_REJECTED: 'CHILD_CONNECTION_REJECTED',
    CHILD_EMAIL_NOT_FOUND: 'CHILD_EMAIL_NOT_FOUND',
    CONNECTION_ALREADY_ACCEPTED: 'CONNECTION_ALREADY_ACCEPTED',
    CONNECTION_ALREADY_REJECTED: 'CONNECTION_ALREADY_REJECTED',
    CONNECTION_ALREADY_REVOKED: 'CONNECTION_ALREADY_REVOKED',
    EMAIL_SENT_RECENTLY: 'EMAIL_SENT_RECENTLY',
    NOTIFIED_RECENTLY: 'NOTIFIED_RECENTLY',
    BAD_BATCH_REQUEST: 'BAD_BATCH_REQUEST'
};
//# sourceMappingURL=index.js.map